import { createContext, useContext, useMemo, useState } from "react";

type PublishContextValue = {
  publishModalOpen: boolean;
  setPublishModalOpen: (open: boolean) => void;
};

const PublishContext = createContext<PublishContextValue | undefined>(
  undefined,
);

export const PublishProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [publishModalOpen, setPublishModalOpen] = useState(false);
  const value = useMemo(
    () => ({ publishModalOpen, setPublishModalOpen }),
    [publishModalOpen],
  );
  return (
    <PublishContext.Provider value={value}>{children}</PublishContext.Provider>
  );
};

export const usePublish = () => {
  const context = useContext(PublishContext);
  if (!context)
    throw new Error("usePublish must be used within PublishProvider");
  return context;
};
